import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateMyMM: NDateLocale = {
  name: 'my-MM',
  locale: enUS
}

export default dateMyMM
